import firebase from 'firebase';
import { globalActionTypes } from './Reducers/GlobalReducer';
import { userActionTypes } from './Reducers/userReducer';
import { generateKeyWords } from './userService';

let userDocSubscriber;

export const roles = {
    ADMIN: 'admin',
    BASIC: 'basic',
};


export const signIn = async () => {
    const auth = firebase.auth();
    const firestore = firebase.firestore();
    const provider = new firebase.auth.GoogleAuthProvider();

    try {
        const cred = await auth.signInWithPopup(provider);
        //get the logged user data
        let user = (({ uid, email, displayName, photoURL }) => ({ uid, email, displayName, photoURL }))(cred.user);
        //get user record if exist
        const userRecRef = firestore.collection('users').doc(user.uid);
        const userDoc = await userRecRef.get();
        if (userDoc.exists) {
            await userRecRef.update({
                ...user,
                keywords: generateKeyWords(user.displayName),
            });
        } else {
            user = {
                ...user,
                role: roles.BASIC,
                created: firebase.firestore.FieldValue.serverTimestamp(),
                keywords: generateKeyWords(user.displayName),
            };
            await userRecRef.set(user);
            const addRole = firebase.functions().httpsCallable('addRole');
            await addRole({
                uid: user.uid,
                role: roles.BASIC,
            }).then((res) => console.log(res));
        }
    } catch (error) {
        console.log(error);
    }
};

export const signOut = async (globalDispatch, userDispatch) => {
    try {
        // sign out user
        await firebase.auth().signOut();
    } catch (error) {
        console.log(error);
    }
};

export const onAuthStateChanged = (globalDispatch, userDispatch) => {
    const firestore = firebase.firestore();
    firebase.auth().onAuthStateChanged({
        next: async (loggedUser) => {
            console.log('fireed');
            if (loggedUser) {
                const userId = loggedUser.uid;
                if (!userDocSubscriber) {
                    userDocSubscriber = firestore.collection('users').doc(userId).onSnapshot({
                        next: async (user) => {
                            //let rl = await loggedUser.getIdTokenResult(true);
                            const userToken = await loggedUser.getIdTokenResult(true);
                            const role = userToken.claims.role ? userToken.claims.role : roles.BASIC;
                            //console.log(rl, role);
                            setUserAuthData({
                                displayName: userToken.claims.name,
                                email: userToken.claims.email,
                                photoURL: userToken.claims.picture,
                                uid: userToken.claims.user_id,
                                role: role,
                            }, globalDispatch, userDispatch);
                        },
                        error: (err) => console.log(err)
                    });
                }
            } else {
                setNullAuth(globalDispatch, userDispatch);
                console.log(userDocSubscriber);
                userDocSubscriber = null;
            }
        },
        error: (error) => console.log(error),
    });
};

const setUserAuthData = (user, globalDispatch, userDispatch) => {
    globalDispatch({
        type: globalActionTypes.SET_LOGGEDIN,
        loggedIn: true,
    });
    userDispatch({
        type: userActionTypes.SET_LOGGED_USER,
        loggedUserData: user,
    });
    globalDispatch({
        type: globalActionTypes.SET_GLOBAL_AUTH_LOADING,

        globalAuthLoading: false,
    });
};

const setNullAuth = (globalDispatch, userDispatch) => {
    globalDispatch({
        type: globalActionTypes.SET_LOGGEDIN,
        loggedIn: false,
    });
    userDispatch({
        type: userActionTypes.SET_LOGGED_USER,
        loggedUserData: null,
    });
    globalDispatch({
        type: globalActionTypes.SET_GLOBAL_AUTH_LOADING,
        globalAuthLoading: false,
    });
};

